module.exports = __webpack_public_path__ + "img/wagb-screen-2.d72f2dc6.webp";